/**
 * @generated SignedSource<<cf7b63a1c7207d358a7ed2b384cc08e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PIIConfigInput = {
  excludedEntities: ReadonlyArray<string>;
};
export type SettingsAlertsPageUpdatePiiMutation$variables = {
  input: PIIConfigInput;
};
export type SettingsAlertsPageUpdatePiiMutation$data = {
  readonly updatePiiConfig: {
    readonly success: boolean;
  };
};
export type SettingsAlertsPageUpdatePiiMutation = {
  response: SettingsAlertsPageUpdatePiiMutation$data;
  variables: SettingsAlertsPageUpdatePiiMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdatePiiConfigPayload",
    "kind": "LinkedField",
    "name": "updatePiiConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SettingsAlertsPageUpdatePiiMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SettingsAlertsPageUpdatePiiMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "50502c885682d0a1d05b4f4da05f9a04",
    "id": null,
    "metadata": {},
    "name": "SettingsAlertsPageUpdatePiiMutation",
    "operationKind": "mutation",
    "text": "mutation SettingsAlertsPageUpdatePiiMutation(\n  $input: PIIConfigInput!\n) {\n  updatePiiConfig(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "722db226a5d22587f79b87ca025e70af";

export default node;
